module.exports = __webpack_public_path__ + "img/15-800x800.93e78843.jpg";